module.exports = __webpack_public_path__ + "static/mesh-0466c2bf60c11b684a3f4dc7b2f6c783.svg";